import React, { useEffect, useState, lazy } from 'react';
import { Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import _ from 'lodash';
import { getData, onAuthStateChanged } from '../src/store/actions';
import quickTipsSeenService from './services/QuickTipsSeenService';
import './components/AdminScreen/admin.css';
import './styles/css/style.css';

import { signOut } from '../src/store/actions';
const Login = lazy(() => import('./components/Login'));
const Signup = lazy(() => import('./components/Signup'));
const Dashboard = lazy(() => import('./components/Dashboard'));
const AdminScreen = lazy(() => import('./components/AdminScreen'));
const ClinicList = lazy(() => import('./components/ClinicList'));
const EnterpriseClinicCreatePage = lazy(() => import('./components/Enterprise/EnterpriseClinicCreatePage'));
const AddCarePlanTemplates = lazy(() =>
  import('./components/AddCarePlanTemplates')
);
const AdminQuickTips = lazy(() => import('./components/AdminQuickTips'));
const Clinicdetail = lazy(() => import('./components/Clinicdetail'));
const Careplan = lazy(() => import('./components/Careplan'));
const HealthNotes = lazy(() => import('./components/HealthNotes'));
const Addcareplan = lazy(() => import('./components/Addcareplan'));
const AppointmentsCalendar = lazy(() => import('./components/Common/AppoinmentSchedule/AppointmentsCalendar'));
const AppointmentDetails = lazy(() => import('./components/Common/AppoinmentSchedule/AppointmentDetails'));
const Documents = lazy(() => import('./components/Documents'));
const Progress = lazy(() => import('./components/Progress'));
const VideoChatWrapper = lazy(() => import('./components/VideoChatWrapper'));
const TelehealthChatPage = lazy(() => import('./components/TelehealthChatPage'));
const Subscriptionplan = lazy(() => import('./components/Subscriptionplan'));
const Profile = lazy(() => import('./components/Profile'));
const PaymentStatus = lazy(() => import('./components/Common/PaymentStatus'));
const PaymentCancelled = lazy(() => import('./components/Common/PaymentCancelled'));
const ResetPassword = lazy(() => import('./components/ResetPassword'));
const CareBuddySetup = lazy(() => import('./components/CareBuddySetup'));
const Loader = lazy(() => import('./components/Loader'));
const Notification = lazy(() => import('./Notification'));
const Layout = lazy(() => import('./Layout'));
const FallPreventionChartView = lazy(() => import('./components/Dashboard/FallPreventionChartView'));
const ManageProviderDirectory = lazy(() => import('./components/ProviderDirectory/Manage'));
// const AdminProviderDirectorySettings = lazy(() => import('./components/AdminScreen/ProviderDirectorySettings'));
const PublicDirectory = lazy(() => import('./components/PublicDirectory'));
const WorkWithUsForm = lazy(() => import('./components/PublicDirectory/WorkWithUsForm'));
const WorkWithUsAdmin = lazy(() => import('./components/WorkWithUsAdmin'));
const ProviderRegistration = lazy(() => import('./components/ProviderRegistration'));
const AppointmentDeepLink = lazy(() => import('./components/Common/AppointmentDeepLink'));
// const Chat = lazy(() => import('./components/ProviderPatientChat/ProvderPatientChat'));

const cookie = new Cookies();

const initialState = {
  authenticated: null,
  isLoading: true,
  role: null,
  isLogged: false,
  user: {},
};

const token = localStorage.getItem('user');
const QUICK_TIPS_SEEN_KEY = 'quickTipsSeen';

const mergeAndStoreQuickTipsSeen = (contextsFromDb) => {
  try {
    const existingRaw = localStorage.getItem(QUICK_TIPS_SEEN_KEY);
    const existing = existingRaw ? JSON.parse(existingRaw) : [];
    const base = Array.isArray(existing) ? existing : [];
    const incoming = Array.isArray(contextsFromDb) ? contextsFromDb : [];
    const merged = Array.from(new Set([...base, ...incoming]));
    localStorage.setItem(QUICK_TIPS_SEEN_KEY, JSON.stringify(merged));
  } catch (e) {
    // ignore
  }
};

const allRoutes = [
  {
    id: 'login',
    component: Login,
    path: '/login',
    isAuth: true,
    exact: true,
    default: true,
    redirect: '/dashboard',
  },
  // {
  //   id: 'chat',
  //   component: Chat,
  //   path: '/chat',
  //   isAuth: false,
  //   exact: true,
  //   role: 'user',
  //   default: true,
  // },
  {
    id: 'signup',
    component: Signup,
    path: '/signup',
    isAuth: true,
    exact: true,
    default: true,
    redirect: '/dashboard',
  },
  {
    id: 'reset_password',
    component: ResetPassword,
    path: '/resetPassword',
    isAuth: true,
    exact: true,
    default: true,
    redirect: '/dashboard',
  },
  {
    id: 'care_buddy_setup',
    component: CareBuddySetup,
    path: '/care-buddy-setup',
    isAuth: true,
    exact: true,
    default: true,
    redirect: '/dashboard',
  },
  {
    id: 'reset_password_admin',
    component: ResetPassword,
    path: '/admin/resetPassword',
    isAuth: true,
    exact: true,
    default: true,
    isAdminAuthRoute: true,
    redirect: '/admin/dashboard',
  },
  {
    id: 'admin_login',
    requiredSession: true,
    component: Login,
    path: '/admin',
    isAuth: true,
    default: true,
    isAdminAuthRoute: true,
    exact: true,
    redirect: '/admin/dashboard',
  },
  {
    id: 'user_profile',
    requiredSession: true,
    component: Profile,
    path: '/profile/:id',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'admin_profile',
    requiredSession: true,
    component: Profile,
    path: '/admin/profile',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
  },
  {
    id: 'user_dashboard',
    requiredSession: true,
    component: Dashboard,
    path: '/dashboard',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'admin_dashboard',
    requiredSession: true,
    component: AdminScreen,
    path: '/admin/dashboard',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_quicktips',
    requiredSession: true,
    component: AdminQuickTips,
    path: '/admin/quicktips',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_patient_list',
    requiredSession: true,
    component: Dashboard,
    path: '/admin/patients',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_single_patient_careplan',
    requiredSession: true,
    component: Careplan,
    path: '/admin/careplan/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_single_patient_progress',
    requiredSession: true,
    component: Progress,
    path: '/admin/progress/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_single_patient_documents',
    requiredSession: true,
    component: Documents,
    path: '/admin/documents/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_single_patient_health_notes',
    requiredSession: true,
    component: HealthNotes,
    path: '/admin/healthnotes/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_clinic_details',
    requiredSession: true,
    component: Clinicdetail,
    path: '/admin/clinicdetail/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'admin_clinic_list',
    requiredSession: true,
    component: ClinicList,
    path: '/admin/clinics',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
  },
  {
    id: 'admin_create_clinic',
    requiredSession: true,
    component: EnterpriseClinicCreatePage,
    path: '/admin/clinics/new',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'add_care_plan_templates',
    requiredSession: true,
    component: AddCarePlanTemplates,
    path: '/admin/care-plan-templates/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
  },
  {
    id: 'new_add_care_plan_templates',
    requiredSession: true,
    component: AddCarePlanTemplates,
    path: '/care-plan-templates',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
  },
  {
    id: 'admin_add_care_plan',
    requiredSession: true,
    component: Addcareplan,
    path: '/admin/addcareplan/:id',
    isAuth: false,
    exact: true,
    role: 'admin',
    redirect: '/admin',
    isAdminAuthRoute: true,
  },
  {
    id: 'clinic_details',
    requiredSession: true,
    component: Clinicdetail,
    path: '/clinicdetail',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'manage_provider_directory',
    requiredSession: true,
    component: ManageProviderDirectory,
    path: '/clinic/provider-directory',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  // Work With Us applications review — admin only (Phase 01B.1 Plan 03).
  {
    id: 'work_with_us_applications',
    requiredSession: true,
    component: WorkWithUsAdmin,
    path: '/clinic/work-with-us-applications',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  // Public-facing Provider Directory page (Phase 1A.3). No auth required —
  // security comes from the embed token in the URL query (?t=<token>). The
  // isPublic flag tells <Layout> to bypass the authenticated app shell.
  // See nomadiccare-web/docs/MARKETPLACE_PROVIDER_DIRECTORY_PLAN.md §5.2.
  {
    id: 'public_provider_directory',
    component: PublicDirectory,
    path: '/provider-directory/embed/:clinicId',
    isPublic: true,
    isAuth: false,
    exact: true,
  },
  // Work With Us application form (Phase 01B.1). Public route — no auth.
  // Prospective providers reach this from the informational dialog on the
  // Provider Directory page. Form component created in Phase 01B.1 Plan 02.
  {
    id: 'work_with_us',
    component: WorkWithUsForm,
    path: '/work-with-us/:clinicId',
    isPublic: true,
    isAuth: false,
    exact: true,
  },
  // Provider Registration journey (Phase 01B.2). Public route — the provider
  // reaches it via the token link in their acceptance email.
  {
    id: 'provider_registration',
    component: ProviderRegistration,
    path: '/provider-registration',
    isPublic: true,
    isAuth: false,
    exact: true,
  },
  {
    id: 'appointment',
    requiredSession: true,
    component: AppointmentsCalendar,
    path: '/appointment',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'appointment_deeplink',
    component: AppointmentDeepLink,
    path: '/telehealth-appointment',
    isPublic: true,
    isAuth: false,
    exact: true,
  },
  {
    id: 'appointment_details',
    requiredSession: true,
    component: AppointmentDetails,
    path: '/appointment-details/:appointmentId',
    isAuth: false,
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'care_plan',
    requiredSession: true,
    component: Careplan,
    path: '/careplan/:id',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'health_notes',
    requiredSession: true,
    component: HealthNotes,
    path: '/healthnotes/:id/(condition)?/:conditionId?',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'add_care_plan',
    requiredSession: true,
    component: Addcareplan,
    path: '/addcareplan/:id',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'telehealth',
    requiredSession: true,
    component: VideoChatWrapper,
    path: '/telehealth/appointment/:appointmentId',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'telehealth_task',
    requiredSession: true,
    component: VideoChatWrapper,
    path: '/telehealth/:id',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'telehealth-chat',
    requiredSession: true,
    component: TelehealthChatPage,
    path: '/telehealth-chat/:taskId',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  // /checkout/cancelled must match BEFORE /checkout/:status — React Router
  // Switch picks the first match. Otherwise PaymentStatus catches the
  // cancelled URL and renders an empty success card.
  {
    id: 'payment_cancelled',
    requiredSession: true,
    component: PaymentCancelled,
    path: '/checkout/cancelled',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'payment_status',
    requiredSession: true,
    component: PaymentStatus,
    path: '/checkout/:status',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'documents',
    requiredSession: true,
    component: Documents,
    path: '/documents/:id',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'user_progress',
    requiredSession: true,
    component: Progress,
    path: '/progress/:id',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'subscription_plan',
    requiredSession: true,
    component: Subscriptionplan,
    path: '/subscriptionplan',
    exact: true,
    role: 'user',
    redirect: '/login',
  },
  {
    id: 'fall_prevention_chart',
    component: FallPreventionChartView,
    path: '/fall-prevention-chart/:patientId',
    isAuth: true,
    exact: true,
    default: true,
  },
];

const App = ({ adminData, ...props }) => {
  const [user, setUser] = useState(initialState);
  const [loaderDone, setLoaderDone] = useState(false);
  // One-time latch: fires once when auth first resolves, never resets.
  // Decouples the loader's isReady signal from ongoing auth state changes
  // (login, registration, biometric) so those flows never retrigger the loader.
  const [routesReady, setRoutesReady] = useState(false);

  useEffect(() => {
    if (!user.isLoading && !routesReady) {
      setRoutesReady(true);
    }
  }, [user.isLoading, routesReady]);

  // Safety release: if Firebase never resolves, force the loader out after 10s
  useEffect(() => {
    const timeout = setTimeout(() => setRoutesReady(true), 5000);
    return () => clearTimeout(timeout);
  }, []);
  setTimeout(() => {
    if (!adminData) {
      signOut();
    } else {
      localStorage.clear();
      window.location.reload();
    }
  }, 16200000);

  const handleAdminUser = () => {
    const userData = JSON.parse(adminData);
    setUser({
      authenticated: !!userData?.user_id,
      isLoading: false,
      isAdmin: userData?.isAdmin,
      role: userData?.role,
      isLogged: !!userData?.user_id,
      user: userData,
    });
  };

  const handleUser = async () => {
    try {
      setUser({
        ...user,
        isLoading: true,
      });

      const authenticated = await new Promise((resolve, reject) => {
        onAuthStateChanged((err, authenticated) => {
          if (!err) {
            resolve(authenticated);
          } else {
            reject(err);
          }
        });
      });

      // console.log('authenticated', authenticated);

      if (authenticated.emailVerified) {
        // Every user — whether they use Google Authenticator (providers) or
        // SMS OTP (carers) — must have completed MFA this session.
        // mfa_verified is set by onMfaSuccess() in both flows and cleared on
        // sign-out via localStorage.clear(). If it is missing the user must
        // go through the login + MFA flow again.
        const mfaVerified = localStorage.getItem('mfa_verified') === 'true';

        if (!mfaVerified) {
          setUser({ ...initialState, isLoading: false });
          return;
        }

        if (
          !_.isEmpty(cookie.get('user', { path: '/' })) &&
          authenticated.emailVerified
        ) {
          // console.log('if runnner ----');
          // console.log(
          //   'user after login1 --- -',
          //   cookie.get('user', { path: '/' }) || {}
          // );

          // Hydrate quick tips "seen" from DB for this user
          try {
            const contexts = await quickTipsSeenService.getSeenContexts(authenticated?.uid);
            mergeAndStoreQuickTipsSeen(contexts);
          } catch (e) {
            // ignore
          }

          setUser({
            user: cookie.get('user', { path: '/' }) || {},
            authenticated: authenticated?.uid,
            isLoading: false,
            role: 'user',
            isLogged: true,
            emailVerified: authenticated.emailVerified,
          });
        } else {
          await getData('users', authenticated?.uid, async (err, userRes) => {
            delete userRes.tokens;
            await cookie.set('user', userRes || {}, { path: '/' });
            console.log('user after login2 --- -', userRes, authenticated);

            // Hydrate quick tips "seen" from DB for this user
            try {
              const contexts = await quickTipsSeenService.getSeenContexts(authenticated?.uid);
              mergeAndStoreQuickTipsSeen(contexts);
            } catch (e) {
              // ignore
            }

            setUser({
              user: userRes ? userRes : {},
              authenticated: authenticated?.uid,
              isLoading: false,
              role: 'user',
              isLogged: true,
              emailVerified: authenticated.emailVerified,
            });
          });
        }
      } else {
        setUser({ ...initialState, isLoading: false });
        signOut();
      }
    } catch (error) {
      console.error('Error in handleUser:', error);
      setUser({ ...initialState, isLoading: false });
    }
  };

  // const handleUser = async () => {
  //   new Promise((resolve, reject) => {
  //     setUser({
  //       ...user,
  //       isLoading: true
  //     })
  //     onAuthStateChanged(async (err, authenticated) => {

  //       if (!err) {
  //         if (authenticated) {

  //           if (!_.isEmpty(cookie.get("user", { path: "/" }))) {
  //             setUser({
  //               user: cookie.get("user", { path: "/" }) || {},
  //               authenticated: authenticated?.uid,
  //               isLoading: false,
  //               role: "user",
  //               isLogged: true,
  //             })
  //           } else {
  //             await getData("users", authenticated?.uid, async (err, userRes) => {
  //               console.log("eww-----", userRes);
  //               cookie.set("user", userRes || {}, { path: "/" })
  //               setUser({
  //                 user: userRes ? userRes : {},
  //                 authenticated: authenticated?.uid,
  //                 isLoading: false,
  //                 role: "user",
  //                 isLogged: true,
  //               })
  //             })
  //           }

  //         } else {
  //           setUser({ ...initialState, isLoading: false });
  //         }
  //       }
  //     });
  //   });
  // };

  useEffect(() => {
    adminData ? handleAdminUser() : handleUser();
    // eslint-disable-next-line
  }, [adminData, token]);

  // const handleUser = async () => {
  //   new Promise((resolve, reject) => {
  //     onAuthStateChanged(async (err, authenticated) => {

  //       console.log("cookie", cookie.get("user", { path: "/" }) || {});
  //       if (!err) {
  //         authenticated && cookie.get("user", { path: "/" })
  //           ? setUser({
  //             user: cookie.get("user", { path: "/" }) || {},
  //             authenticated: authenticated?.uid,
  //             isLoading: false,
  //             role: "user",
  //             isLogged: true,
  //           })
  //           : setUser({ ...initialState, isLoading: false });

  //         resolve();
  //       } else {
  //         reject(err);
  //       }
  //     });
  //   });
  // };

  const roleWiseAccess = (access) => {
    // Public routes (Provider Directory iframe / standalone page) are always
    // accessible — independent of role / login state.
    const publicRoutes = allRoutes.filter((val) => val.isPublic);
    if (!user.role) {
      return [...publicRoutes, ...allRoutes.filter((val) => val.default)];
    } else {
      const cloneData = allRoutes.filter((val) => val?.role === access);
      const roleRoutes = cloneData.length
        ? cloneData
        : allRoutes.filter((val) => val.default);
      return [...publicRoutes, ...roleRoutes];
    }
  };

  const handleIsLoggedIn = () => {
    // Trust in-memory auth state only to avoid MFA bypass on refresh
    return !!user.isLogged && !!user.role;
  };
  return (
    <div className="app-layout" {...props}>
      <Notification />
      <BrowserRouter>
        {!loaderDone && (
          <Loader
            isReady={routesReady}
            onComplete={() => setLoaderDone(true)}
          />
        )}
        {!user.isLoading && (
          <Switch>
            {roleWiseAccess(user.role).map(
              (
                {
                  requiredSession,
                  redirect,
                  isAdminAuthRoute,
                  isPublic,
                  id,
                  isAuth,
                  component: Component,
                  ...extraData
                },
                index
              ) => {
                return (
                  <Route
                    key={index}
                    {...extraData}
                    render={(props) => (
                      <Layout
                        user={user}
                        component={Component}
                        {...props}
                        {...{
                          requiredSession,
                          isAuth,
                          redirect,
                          isAdminAuthRoute,
                          isPublic,
                          id,
                          ...extraData,
                        }}
                      />
                    )}
                  />
                );
              }
            )}
            {handleIsLoggedIn() && user.role ? (
              <Route
                path="*"
                render={() => (
                  <Redirect
                    to={{
                      pathname:
                        user.role === 'admin'
                          ? '/admin/dashboard'
                          : '/dashboard',
                    }}
                  />
                )}
              />
            ) : (
              <Redirect to="/login" />
            )}
          </Switch>
        )}
      </BrowserRouter>
    </div>
  );
};

export default App;
